export default __webpack_public_path__ + "static/media/ditches_and_furrows.4634ff49.png";